import callAPI from "../callApi";
import path from "../variables";

const featureFlags = {
	// Resolved features for the current user (Frontend store hydration).
	// skipCache : la réponse est SCOPÉE au user authentifié — un cache
	// d'URL global (cf. callApi.ts:15) servirait la map d'un autre user
	// ou d'une session précédente après un logout/relogin SPA. Toujours
	// frais.
	me: () => callAPI("GET", `${path.base}/features/me`, "", "fetching my features", { skipCache: true }),

	// Root-only registry CRUD
	definitions: {
		getAll: (filter?: string) =>
			callAPI("GET", `${path.base}/administration/feature-definitions${filter || ""}`, "", "listing feature definitions"),
		categories: () =>
			callAPI("GET", `${path.base}/administration/feature-definitions/categories`, "", "listing categories"),
		update: (key: string, data: any) =>
			callAPI("PUT", `${path.base}/administration/feature-definitions/${encodeURIComponent(key)}`, data, "updating definition"),
	},

	// Enterprise-level toggles (Root + Admin)
	enterprise: {
		getAll: (filter?: string) =>
			callAPI("GET", `${path.base}/administration/enterprise-features${filter || ""}`, "", "listing enterprise features"),
		toggle: (data: { feature_key: string; enabled: boolean; value?: any; enterprise?: string }) =>
			callAPI("PUT", `${path.base}/administration/enterprise-features/toggle`, data, "toggling enterprise feature"),
		bulkUpdate: (data: { enterprise: string; features: Array<{ feature_key: string; enabled: boolean; value?: any }> }) =>
			callAPI("PUT", `${path.base}/administration/enterprise-features/bulk`, data, "bulk update enterprise features"),
	},

	// Station-level overrides (Admin entreprise)
	station: {
		getAll: (stationId: number) =>
			callAPI("GET", `${path.base}/administration/stations/${stationId}/features`, "", "listing station features"),
		update: (stationId: number, key: string, data: { override_mode: "inherit" | "force_on" | "force_off"; value?: any }) =>
			callAPI("PUT", `${path.base}/administration/stations/${stationId}/features/${encodeURIComponent(key)}`, data, "updating station override"),
		applyPreset: (stationId: number, preset: "small" | "medium" | "large") =>
			callAPI("POST", `${path.base}/administration/stations/${stationId}/features/apply-preset`, { preset }, "applying preset"),
	},
};

export default featureFlags;
